/**
 * Download do HTML da proposta (mesmo conteúdo usado no PDF HangSix / Amazon).
 * Imagens são embutidas em data URL para o arquivo abrir fora do sistema.
 */

import { saveAs } from 'file-saver'
import { getBase64FromUrl } from './constantes'

export function salvarHtmlProposta(html, fileName) {
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' })
  saveAs(blob, fileName)
}

export function nomeArquivoHtmlDePdf(fileNamePdf) {
  return String(fileNamePdf || 'Proposta.html').replace(/\.pdf$/i, '.html')
}

export async function htmlComImagensEmbutidas(html) {
  const urls = new Set()
  const re = /(?:src)=["']([^"']+)["']/gi
  let m
  while ((m = re.exec(html))) {
    const u = m[1]
    if (!u || u.startsWith('data:') || u.startsWith('#') || u.startsWith('mailto:')) continue
    urls.add(u)
  }
  let out = html
  for (const url of urls) {
    const data = await getBase64FromUrl(url)
    if (data) out = out.split(url).join(data)
  }
  return out
}
